import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Gallery.css";

// Dynamischer Import aller Bilder aus dem Gallery-Ordner
const importAll = (r) => r.keys().map(r);
const images = importAll(require.context("../../assets", false, /\.(png|jpe?g|svg|webp)$/));

const Gallery = () => {
  return (
    <Container className="gallery-section">
      <h2 className="text-center">Bildergalerie</h2>
      <p className="text-center">Ein Einblick in unsere Arbeiten.</p>
      
      <Row>
        {images.map((img, index) => (
          <Col md={4} sm={6} xs={12} key={index} className="mb-4">
            <div className="gallery-item">
              <img src={img} alt={`Galeriebild ${index + 1}`} className="gallery-img" />
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Gallery;
